<template>
  <div class="page-header">
    <div class="page-header__breadcrumbs">
      <AtomBreadcrumbs />
    </div>
    <h1 class="page-header__heading" v-html="heading" />
    <p v-if="leading" class="page-header__leading" v-html="leading" />
  </div>
</template>

<script setup>
const props = defineProps({
  heading: {
    type: String,
    default: () => ''
  },
  leading: {
    type: String,
    default: () => ''
  }
})
</script>

<style lang="scss" scoped>
.page-header {
  @apply max-w-prose;

  &__breadcrumbs {
    @apply mb-4 lg:mb-6;
  }
  
  &__heading {
    @apply font-heading font-bold;
    @apply text-4xl sm:text-5xl md:text-6xl;
  }

  &__leading {
    // 
  }
}
</style>